<template>
    <div class="col-sm-12 houses-component-container">
        <div class="row">
            <div class="col-sm-12">
                <div class="house-component-row">
                    <house-list-item v-for="(house, index) in houses"
                                     :houseId="house.id"
                                     :key="house.id"
                                     :index="index">
                    </house-list-item>
                    <div class="house-component--new">
                        <div class="house-component-inner--new js-houses-component-eq-height">
                            <div class="house-component--new-inputs">
                                <template v-if="canAddHouses">
                                    <span @click.prevent="showModal()">
                                        <button type="button" class="btn btn--round house-component-add">
                                            <span class="spinner glyphicon glyphicon-plus"></span>
                                        </button>
                                        <a href="#" class="add-house-link">Nytt hus</a>
                                    </span>
                                </template>
                                <modal name="add-house-modal" :width="750" :height="760" draggable="true">
                                    <div v-if="isBasedOnCustomReferenceHouses">
                                        <custom-reference-house :onCancel="hideModal" :onOk="addCustomRefHouse"/>
                                    </div>
                                    <div v-else>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <h2 class="add-house-modal-heading">Välj referenshus</h2>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="add-house-modal-filter">
                                                    <reference-house-filter/>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <carousel></carousel>
                                        </div>

                                        <div class="row top-buffer modal-actions">
                                            <div class="col-sm-6 text-left">
                                                <a href="#" @click.prevent="hideModal()">Avbryt</a>
                                            </div>
                                            <div class="col-sm-6 text-right">
                                                <button type="submit" class="btn btn-primary"
                                                        @click.prevent="addNewHouse()">
                                                    <span class="spinner">Använd detta hus</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters, mapState} from "vuex"
    import HouseListItem from "./house"
    import Carousel from "./houseCarousel"
    import ReferenceHouseFilter from "./refHouseFilter"
    import CustomReferenceHouse from "./customRefHouse"

    const setEqualHouseBoxHeight = function () {
        // this is not a great way to do this, but I'll leave it for now,
        // for legacy reasons
        const maxHeight = Math.max.apply(null, $(".js-houses-component-eq-height")
            .map(function () {
                return $(this).height()
            }).get())
        $(".js-houses-component-eq-height").height(maxHeight)
    }

    export default {
        data() {
            return {
                selectedReferenceHouseId: 0,
            }
        },

        computed: {
            ...mapGetters([
                "procurementModel",
                "canAddMoreHouses"
            ]),
            ...mapState({
                currentCustomReferenceHouse: state => state.refHouses.currentCustomReferenceHouse,
            }),
            houses() {
                return this.$store.state.houses.houses
            },
            isProjectClosed() {
                return this.$store.getters.isProjectClosed;
            },
            hasProcurementModel() {
                return this.$store.getters.procurementModel !== null;
            },
            canAddHouses() {
                return this.hasProcurementModel && !this.isProjectClosed && this.canAddMoreHouses;
            },
            isBasedOnCustomReferenceHouses() {
                return this.procurementModel == 2 || this.procurementModel == 4;
            }
        },

        methods: {
            ...mapActions([
                'createHouse',
                'createHouseWithCustomRefHouse',
            ]),
            showModal() {
                this.$modal.show('add-house-modal')
            },
            hideModal() {
                this.$modal.hide('add-house-modal')
            },
            addNewHouse() {
                this.createHouse()
                this.$modal.hide('add-house-modal')
            },
            addCustomRefHouse(customReferenceHouse) {
                this.$store.commit("setCurrentCustomReferenceHouse", customReferenceHouse)
                this.createHouseWithCustomRefHouse(this.currentCustomReferenceHouse)
                this.$modal.hide('add-house-modal')
            }
        },

        components: {
            HouseListItem,
            Carousel,
            ReferenceHouseFilter,
            CustomReferenceHouse,
        },

        mounted() {
            setEqualHouseBoxHeight();
        },

        updated() {
            setEqualHouseBoxHeight();
        },
    }
</script>

<style lang="scss">
    // SCSS is found in houses-component.scss and is shared with other Houses non-Vue component
    .house-component--new {
        padding: 3px;

        .house-component-inner--new {
            padding: 10px;

            .add-house-modal-heading {
                text-align: center;
                padding: 0 65px;
            }

            .add-house-modal-filter {
                padding: 0 65px 10px 65px;
            }
        }

        .modal-actions {
            padding: 0 65px;

            &.top-buffer {
                margin-bottom: 20px;
            }
        }

        .v--modal-box {
            overflow-y: auto !important;
        }
    }
</style>



// WEBPACK FOOTER //
// assets/vue/houseModel/components/houseList.vue